import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { PhoneMaskDirective } from './phone-mask.directive';
import { AppComponent } from './app.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { HomeComponent } from './home/home.component';
import { SelectProjectComponent } from './select-project/select-project.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { IssueManagementComponent } from './issue-management/issue-management.component';
import { ProjectManagementComponent } from './project-management/project-management.component';
import { ProjectDetailComponent } from './project-detail/project-detail.component';
import { nl2brPipe } from './nl2br.pipe';
import { SumByPropertyPipe } from './pipes/sum-by-property.pipe';
import { DecimalFormatPipe } from './pipes/decimal-format.pipe';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FullCalendarModule } from '@fullcalendar/angular'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import interactionPlugin from '@fullcalendar/interaction'; // a plugin!

import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatBadgeModule } from '@angular/material/badge';
import { MatMenuModule } from '@angular/material/menu';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HeaderComponent } from './header/header.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';

import { LookupManagementComponent } from './lookup-management/lookup-management.component';
import { MatTabsModule } from '@angular/material/tabs';
import * as bootstrap from "bootstrap";
import * as $ from 'jquery';
import { ModalbootstrapComponent } from './modalbootstrap/modalbootstrap.component';
import { UploadComponent } from './upload/upload.component';
import { CompanyManagementComponent } from './company-management/company-management.component';
import { FieldErrorDisplayComponent } from './field-error-display/field-error-display.component';
import { ProjectsaleManagementComponent } from './projectsale-management/projectsale-management.component';
import { SelectProjectsaleComponent } from './select-projectsale/select-projectsale.component';
import { SaletrackingManagementComponent } from './saletracking-management/saletracking-management.component';
import { UserDetailComponent } from './user-detail/user-detail.component';
import { PiechartComponent } from './piechart/piechart.component';
import { ChartsModule } from 'ng2-charts';
import { MatExpansionModule } from '@angular/material/expansion';
import { GanttChartControlComponent } from './gantt-chart-control/gantt-chart-control.component';
import { FormControlDynamicComponent } from './form-control-dynamic/form-control-dynamic.component';
import { LoadingControlsComponent } from './loading-controls/loading-controls.component';
import { PaginationControlsComponent } from './pagination-controls/pagination-controls.component';
import { TicketManagementComponent } from './ticket-management/ticket-management.component';
import { SelectProjectticketComponent } from './select-projectticket/select-projectticket.component';
import { WorklistComponent } from './worklist/worklist.component';
import { TicketFormComponent } from './ticket-form/ticket-form.component';
import { EventComponent } from './event/event.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { MeetingComponent } from './meeting/meeting.component';
import { PortalComponent } from './portal/portal.component';
import { Portal } from '@angular/cdk/portal';
import { UploadDragdropComponent } from './upload-dragdrop/upload-dragdrop.component';
import { ProgressComponent } from './component/progress/progress.component';
import { DndDirective } from './directives/dnd.directive';
import { BaselineDocumentComponent } from './baseline-document/baseline-document.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SalePlanningComponent } from './sale-planning/sale-planning.component';
import { WorklistSaleComponent } from './worklist-sale/worklist-sale.component';
import { WorklistSaleLeadApprovalFormComponent } from './worklist-sale-lead-approval-form/worklist-sale-lead-approval-form.component';
import { WorklistSaleCloseDealFormComponent } from './worklist-sale-close-deal-form/worklist-sale-close-deal-form.component';
import { ReportComponent } from './report/report.component';
import { ReportDetailComponent } from './report-detail/report-detail.component'
import { PipeLineComponent } from './pipe-line/pipe-line.component';
import { TimesheetComponent } from './timesheet/timesheet.component'
import { InformationLeadComponent } from './information-lead/information-lead.component';
import { InformationListLeadProjectComponent } from './information-list-lead-project/information-list-lead-project.component';
import { MenuPortalComponent } from './menu-portal/menu-portal.component';
import { OrganizationalManagementComponent } from './organizational-management/organizational-management.component';
import { GoogleOrgChartComponent } from './component/google-org-chart/google-org-chart.component';
import { ProgressCircleComponent } from './component/progress-circle/progress-circle.component';
import { DashboardDetailComponent } from './dashboard-detail/dashboard-detail.component';
import { GoogleBarChartComponent } from './component/google-bar-chart/google-bar-chart.component'
import { MatChipsModule } from '@angular/material/chips';
import { DashboardSaleComponent } from './dashboard-sale/dashboard-sale.component';
import { DashboardSaleDetailComponent } from './dashboard-sale-detail/dashboard-sale-detail.component';
import { WorklistSaleapprovalComponent } from './worklist-saleapproval/worklist-saleapproval.component';
import { ProjectgroupManagementComponent } from './projectgroup-management/projectgroup-management.component';
import { RoleManagementComponent } from './role-management/role-management.component';
import { GoogleColumnsChartComponent } from './component/google-columns-chart/google-columns-chart.component';
import { InformationRoleComponent } from './information-role/information-role.component';
import { FullcalendarComponent } from './component/fullcalendar/fullcalendar.component';
import { SaleTeamComponent } from './sale-team/sale-team.component';
import { PositionlevelSaleComponent } from './position-level/positionlevel-sale/positionlevel-sale.component';
import { PositionlevelProjectComponent } from './position-level/positionlevel-project/positionlevel-project.component';
import { PositionlevelSupportComponent } from './position-level/positionlevel-support/positionlevel-support.component';
import { DivisionComponent } from './master/division/division.component';
import { DepartmentComponent } from './master/department/department.component';
import { SectionComponent } from './master/section/section.component';
import { UnitComponent } from './master/unit/unit.component';
import { RegionComponent } from './master/region/region.component';
import { BranchComponent } from './master/branch/branch.component';
import { SubBranchComponent } from './master/sub-branch/sub-branch.component';
import { ForgotpasswordComponent } from './user-forgotpassword/user-forgotpassword.component';
import { PasswordExpireComponent } from './user-password-expire/user-password-expire.component';
import { LogLoginComponent } from './log-login/log-login.component';
import { NotfoundComponent } from './component/notfound/notfound.component';
import { InterceptorService } from './service/interceptor.service';
import { NotifierComponent } from './notifier/notifier.component';
import { PositionLevelComponent } from './master/position-level/position-level.component';
import { DoaMasterComponent } from './master/doa-master/doa-master.component';
import { DoaMappingComponent } from './master/doa-mapping/doa-mapping.component';
import { CycleComponent } from './master/cycle/cycle.component';
import { StateComponent } from './master/state/state.component';
import { SubStateComponent } from './master/sub-state/sub-state.component';
import { StatestatusMappingComponent } from './master/statestatus-mapping/statestatus-mapping.component';
import { PipelinestatusManagementComponent } from './pipelinestatus-management/pipelinestatus-management.component';
import { ProjectsaleInformationComponent } from './projectsale-information/projectsale-information.component';
import { AgmCoreModule } from '@agm/core';
import { AnnounceManagementComponent } from './announce-management/announce-management.component';
import { TimesheetWorklistComponent } from './timesheet-worklist/timesheet-worklist.component';
import { ProjectPipelineDetailComponent } from './pipe-line/project-pipeline-detail/project-pipeline-detail.component';
import { TimesheetWorklistApproveComponent } from './timesheet-worklist-approve/timesheet-worklist-approve.component';
//import { AssignMembersupportComponent } from './assign-membersupport/assign-membersupport.component';
import { AssignManagersupportComponent } from './assign-managersupport/assign-managersupport.component';
import { SelectprojectassignManagersupportComponent } from './selectprojectassign-managersupport/selectprojectassign-managersupport.component';
import { AssignMembersupportComponent } from './assign-membersupport/assign-membersupport.component';
import { AssignManagersaleComponent } from './assign-managersale/assign-managersale.component';
import { TimesheetChecklistComponent } from './timesheet-checklist/timesheet-checklist.component';
import { TimesheetChecklistDivisionComponent } from './timesheet-checklist-division/timesheet-checklist-division.component';
import { TimesheetChecklistYearComponent } from './timesheet-checklist-year/timesheet-checklist-year.component';
import { TimesheetChecklistMonthComponent } from './timesheet-checklist-month/timesheet-checklist-month.component';
import { TimesheetReportAccountingComponent } from './timesheet-report-accounting/timesheet-report-accounting.component';
import { TimesheetChecklistOrgcodeComponent } from './timesheet-checklist-orgcode/timesheet-checklist-orgcode.component';
import { TimesheetChecklistYearAllComponent } from './timesheet-checklist-year-all/timesheet-checklist-year-all.component';
import { TimesheetChecklistMonthAllComponent } from './timesheet-checklist-month-all/timesheet-checklist-month-all.component';
import { TimesheetChecklistDivisionAllComponent } from './timesheet-checklist-division-all/timesheet-checklist-division-all.component';
import { ExpenseClaimsComponent } from './expense-claims/expense-claims.component';
import { ExpenseWorklistComponent } from './expense-worklist/expense-worklist.component';
import { ExpenseClaimsItemComponent } from './expense-claims-item/expense-claims-item.component';
import { EmployeeSelectComponent } from './component/employee-select/employee-select.component';
import { SaleLaborRateMasterComponent } from './sale-labor-rate-master/sale-labor-rate-master.component';
import { TimesheetSummaryReportComponent } from './timesheet-summary-report/timesheet-summary-report.component';
import { EffortManagementComponent } from './effort-management/effort-management.component';
import { EffortGroupComponent } from './effort-group/effort-group.component';
import { LeadSelectComponent } from './component/lead-select/lead-select.component';
import { CompanySelectComponent } from './component/company-select/company-select.component';
import { EffortPlanComponent } from './effort-plan/effort-plan.component';
import { ProjectSelectComponent } from './component/project-select/project-select.component';
import { ProjectEffortEstimationComponent } from './project-effort-estimation/project-effort-estimation.component';
import { ProjectPlanActualCompareReportComponent } from './project-plan-actual-compare-report/project-plan-actual-compare-report.component';
import { ProjectAssignManagerComponent } from './project-assign-manager/project-assign-manager.component';
import { SaleTargetManagementComponent } from './sale-target-management/sale-target-management.component';
import { ConversionRateDialogComponent } from './component/conversion-rate-dialog/conversion-rate-dialog.component';
import { UpdatePipelineDialogComponent } from './component/update-pipeline-dialog/update-pipeline-dialog.component';
import { ChannelTypeManagementComponent } from './channel-type-management/channel-type-management.component';
import { ChannelMappingComponent } from './channel-mapping/channel-mapping.component';
import { DealerMappingComponent } from './dealer-mapping/dealer-mapping.component';
import { LeadSummaryByChannelComponent } from './lead-summary-by-channel/lead-summary-by-channel.component';
import { SaleReportComponent } from './sale-report/sale-report.component';
import { ServiceDeliveryBacklogComponent } from './service-delivery-backlog/service-delivery-backlog.component';
import { ServiceDeliveryBacklogDetailComponent } from './service-delivery-backlog-detail/service-delivery-backlog-detail.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ProjectsalereportComponent } from './projectsalereport/projectsalereport.component';
import { ProfitLossReportComponent } from './profit-loss-report/profit-loss-report.component';
import { ProductManagementComponent } from './product-management/product-management.component';
import { ProjectsaleAssetGroupReportComponent } from './projectsale-asset-group-report/projectsale-asset-group-report.component';
import { ProjectAxisComponent } from './project-axis/project-axis.component';
import { ProfitLossReportDialogComponent } from './dialogs/profit-loss-report-dialog.component';
import { AssetManagementComponent } from './asset-management/asset-management.component';
import { SaleHomepageComponent } from './sale-homepage/sale-homepage.component';
import { CommonModule, DatePipe } from '@angular/common';
import { SilentErrorHandler } from './silent-error-handler';
import { ProjectsaleEditComponent } from './projectsale-edit/projectsale-edit.component';
import { ServiceDeliveryBacklogAllComponent } from './service-delivery-backlog-all/service-delivery-backlog-all.component';
import { QuotationManagementComponent } from './quotation-management/quotation-management.component';
import { ProjectsaleAssetGroupAllReportComponent } from './projectsale-asset-group-all-report/projectsale-asset-group-all-report.component';
import { PipeLineElevatedComponent } from './pipe-line-elevated/pipe-line-elevated.component';
import { SaleSummaryReportComponent } from './sale-summary-report/sale-summary-report.component';
import { AssetReportByCustomerComponent } from './asset-report-by-customer/asset-report-by-customer.component';
import { MsalModule, MsalRedirectComponent, MsalInterceptor, MsalGuard, MsalService } from '@azure/msal-angular';
import { PublicClientApplication, InteractionType } from '@azure/msal-browser';
import { msalConfig } from '../environments/environment';
import { ResourcePlanningComponent } from './resource-planning/resource-planning.component';
import { ResourcePlanningReportComponent } from './resource-planning-report/resource-planning-report.component';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimesheetExportComponent } from './timesheet-export/timesheet-export.component';
import { AuthorizeUserComponent } from './authorize-user/authorize-user.component';
import { AuthorizeUserProjectComponent } from './authorize-user/authorize-user-project/authorize-user-project.component';
import { TimesheetSummaryWorklistComponent } from './timesheet-summary-worklist/timesheet-summary-worklist.component';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  interactionPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    PhoneMaskDirective,
    NavMenuComponent,
    HomeComponent,
    SelectProjectComponent,
    UserManagementComponent,
    UserProfileComponent,
    IssueManagementComponent,
    ProjectManagementComponent,
    ProjectDetailComponent,
    nl2brPipe,
    HeaderComponent,
    LookupManagementComponent,
    ModalbootstrapComponent,
    UploadComponent,
    CompanyManagementComponent,
    FieldErrorDisplayComponent,
    ProjectsaleManagementComponent,
    SelectProjectsaleComponent,
    SaletrackingManagementComponent,
    UserDetailComponent,
    PiechartComponent,
    GanttChartControlComponent,
    FormControlDynamicComponent,
    LoadingControlsComponent,
    PaginationControlsComponent,
    TicketManagementComponent,
    SelectProjectticketComponent,
    WorklistComponent,
    TicketFormComponent,
    EventComponent,
    ContactListComponent,
    MeetingComponent,
    PortalComponent,
    UploadDragdropComponent,
    ProgressComponent,
    DndDirective,
    BaselineDocumentComponent,
    DashboardComponent,
    SalePlanningComponent,
    WorklistSaleComponent,
    WorklistSaleLeadApprovalFormComponent,
    WorklistSaleCloseDealFormComponent,
    ReportComponent,
    ReportDetailComponent,
    PipeLineComponent,
    ProjectPipelineDetailComponent,
    TimesheetComponent,
    InformationLeadComponent,
    InformationListLeadProjectComponent,
    MenuPortalComponent,
    OrganizationalManagementComponent,
    GoogleOrgChartComponent,
    ProgressCircleComponent,
    DashboardDetailComponent,
    GoogleBarChartComponent,
    DashboardSaleComponent,
    DashboardSaleDetailComponent,
    WorklistSaleapprovalComponent,
    ProjectgroupManagementComponent,
    RoleManagementComponent,
    InformationRoleComponent,
    GoogleColumnsChartComponent,
    FullcalendarComponent,
    SaleTeamComponent,
    PositionlevelSaleComponent,
    PositionlevelProjectComponent,
    PositionlevelSupportComponent,
    DivisionComponent,
    DepartmentComponent,
    SectionComponent,
    UnitComponent,
    RegionComponent,
    BranchComponent,
    SubBranchComponent,
    LogLoginComponent,
    ForgotpasswordComponent,
    PasswordExpireComponent,
    NotfoundComponent,
    NotifierComponent,
    PositionLevelComponent,
    DoaMasterComponent,
    DoaMappingComponent,
    CycleComponent,
    StateComponent,
    SubStateComponent,
    StatestatusMappingComponent,
    PipelinestatusManagementComponent,
    ProjectsaleInformationComponent,
    AnnounceManagementComponent,
    TimesheetWorklistComponent,
    TimesheetWorklistApproveComponent,
    //AssignMembersupportComponent,
    AssignManagersupportComponent,
    SelectprojectassignManagersupportComponent,
    AssignMembersupportComponent,
    AssignManagersaleComponent,
    TimesheetChecklistComponent,
    TimesheetChecklistDivisionComponent,
    TimesheetChecklistYearComponent,
    TimesheetChecklistMonthComponent,
    TimesheetReportAccountingComponent,
    TimesheetChecklistOrgcodeComponent,
    TimesheetChecklistYearAllComponent,
    TimesheetChecklistMonthAllComponent,
    TimesheetChecklistDivisionAllComponent,
    ExpenseClaimsComponent,
    ExpenseWorklistComponent,
    ExpenseClaimsItemComponent,
    EmployeeSelectComponent,
    SaleLaborRateMasterComponent,
    TimesheetSummaryReportComponent,
    EffortManagementComponent,
    EffortGroupComponent,
    LeadSelectComponent,
    CompanySelectComponent,
    EffortPlanComponent,
    ProjectSelectComponent,
    ProjectEffortEstimationComponent,
    ProjectPlanActualCompareReportComponent,
    ProjectAssignManagerComponent,
    SaleTargetManagementComponent,
    ConversionRateDialogComponent,
    UpdatePipelineDialogComponent,
    ChannelTypeManagementComponent,
    ChannelMappingComponent,
    DealerMappingComponent,
    LeadSummaryByChannelComponent,
    SaleReportComponent,
    SumByPropertyPipe,
    DecimalFormatPipe,
    ServiceDeliveryBacklogComponent,
    ServiceDeliveryBacklogDetailComponent,
    ProjectsalereportComponent,
    ProfitLossReportComponent,
    ProductManagementComponent,
    ProjectsaleAssetGroupReportComponent,
    ProjectAxisComponent,
    ProfitLossReportDialogComponent,
    AssetManagementComponent,
    SaleHomepageComponent,
    ProjectsaleEditComponent,
    ServiceDeliveryBacklogAllComponent,
    QuotationManagementComponent,
    ProjectsaleAssetGroupAllReportComponent,
    PipeLineElevatedComponent,
    SaleSummaryReportComponent,
    AssetReportByCustomerComponent,
    ResourcePlanningComponent,
    ResourcePlanningReportComponent,
    TimesheetExportComponent,
    AuthorizeUserComponent,
    AuthorizeUserProjectComponent,
    TimesheetSummaryWorklistComponent

  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    CommonModule,
    HttpClientModule,
    FormsModule,
    FullCalendarModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      { path: 'select-project', component: SelectProjectComponent },
      { path: 'select-projectsale', component: SelectProjectsaleComponent },
      { path: 'user-management', component: UserManagementComponent },
      { path: 'user-profile', component: UserProfileComponent },
      { path: 'user-detail', component: UserDetailComponent },
      { path: 'issue-management', component: IssueManagementComponent },
      { path: 'project-management', component: ProjectManagementComponent },
      { path: 'project-detail', component: ProjectDetailComponent },
      { path: 'lookup-management', component: LookupManagementComponent },
      { path: 'uploads', component: UploadComponent },
      { path: 'company-management', component: CompanyManagementComponent },
      { path: 'projectsale-management', component: ProjectsaleManagementComponent },
      { path: 'saletracking-management', component: SaletrackingManagementComponent },
      { path: 'piechart', component: PiechartComponent },
      { path: 'formcontroldynamic', component: FormControlDynamicComponent },
      { path: 'loading', component: LoadingControlsComponent },
      { path: 'ticket-management', component: TicketManagementComponent },
      { path: 'select-projectticket', component: SelectProjectticketComponent },
      { path: 'ticket-worklist', component: WorklistComponent },
      { path: 'portal', component: PortalComponent },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'dashboard-detail', component: DashboardDetailComponent },
      { path: 'sale-planning', component: SalePlanningComponent },

      //{ path: 'worklist-sale', component: WorklistSaleComponent },
      { path: 'worklist-sale', component: WorklistSaleapprovalComponent },
      { path: 'worklist-leadapproval', component: WorklistSaleLeadApprovalFormComponent },
      { path: 'worklist-closedeal', component: WorklistSaleCloseDealFormComponent },

      { path: 'report', component: ReportComponent },
      { path: 'report-detail', component: ReportDetailComponent },
      { path: 'pipe-line', component: PipeLineComponent },
      { path: 'time-sheet', component: TimesheetComponent },
      { path: 'informationlead', component: InformationLeadComponent },
      { path: 'informationprojectlead', component: InformationListLeadProjectComponent },
      { path: 'MenuPortal', component: MenuPortalComponent },

      { path: 'project-management/:ForK2/:EmpCode/:UserName/:EmpRoleCode', component: ProjectsaleManagementComponent },
      { path: 'project-detail/:ForK2/:EmpCode/:EmpRoleCode/:ProjectCode', component: ProjectDetailComponent },
      { path: 'select-projectticket/:ForK2/:EmpCode/:Username', component: SelectProjectticketComponent },
      { path: 'ticket-management/:ForK2/:EmpCode/:EmpRoleCode/:ProjectCode/:ProjectName', component: TicketManagementComponent }, //{ path: 'ticket-worklist/:ForK2/:EmpCode/:EmpRoleCode', component: WorklistComponent },
      { path: 'report/:ForK2/:EmpCode/:UserName', component: ReportComponent },
      { path: 'report-detail/:ForK2/:EmpCode/:CompanyCode/:CompanyName/:ProjectCode/:ProjectName', component: ReportDetailComponent },
      { path: 'sale-planning/:ForK2/:EmpCode', component: SalePlanningComponent },
      { path: 'pipe-line/:ForK2/:EmpCode', component: PipeLineComponent },
      { path: 'ticket-worklist/:ForK2/:EmpCode/:EmpRoleCode', component: WorklistComponent },
      { path: 'user-management/:ForK2/:EmpCode', component: UserManagementComponent },
      { path: 'lookup-management/:ForK2/:EmpCode', component: LookupManagementComponent },

      { path: 'dashboard-sale', component: DashboardSaleComponent },
      { path: 'dashboardsale-detail', component: DashboardSaleDetailComponent },

      { path: 'leadgroup-management', component: ProjectgroupManagementComponent },
      { path: 'sale-team', component: SaleTeamComponent },
      { path: 'informationrole', component: InformationRoleComponent },
      { path: 'role-management', component: RoleManagementComponent },
      { path: 'sale-position', component: PositionlevelSaleComponent },
      { path: 'project-position', component: PositionlevelProjectComponent },
      { path: 'support-position', component: PositionlevelSupportComponent },
      { path: 'user-password-expire', component: PasswordExpireComponent },
      { path: 'user-password-expire/:ForK2/:User', component: PasswordExpireComponent },
      { path: 'user-forgotpassword', component: ForgotpasswordComponent },
      { path: 'user-forgotpassword/:ForK2/:User', component: ForgotpasswordComponent },
      { path: 'log-login', component: LogLoginComponent },
      { path: 'master-position', component: PositionLevelComponent },
      { path: 'master-doa', component: DoaMasterComponent },
      { path: 'master-doa-mapping', component: DoaMappingComponent },

      { path: 'master-cycle', component: CycleComponent },
      { path: 'master-state', component: StateComponent },
      { path: 'master-substate', component: SubStateComponent },
      { path: 'master-state-mapping', component: StatestatusMappingComponent },
      { path: 'pipelinestatus-management', component: PipelinestatusManagementComponent },
      { path: 'projectsale-information', component: ProjectsaleInformationComponent },
      { path: 'master-division', component: DivisionComponent },
      { path: 'master-department', component: DepartmentComponent },
      { path: 'master-Section', component: SectionComponent },
      { path: 'master-Unit', component: UnitComponent },
      { path: 'announce-management', component: AnnounceManagementComponent },
      { path: 'timesheet-worklist', component: TimesheetWorklistComponent },
      { path: 'timesheet-worklist-approve', component: TimesheetWorklistApproveComponent },
      { path: 'assignmanager-support', component: AssignManagersupportComponent },
      { path: 'selectprojectassignmanager-support', component: SelectprojectassignManagersupportComponent },
      { path: 'assignmember-support', component: AssignMembersupportComponent },
      { path: 'assignmanager-sale', component: AssignManagersaleComponent },
      { path: 'timesheet-checklist', component: TimesheetChecklistComponent },
      { path: 'timesheet-checklist-division', component: TimesheetChecklistDivisionComponent },
      { path: 'timesheet-checklist-month', component: TimesheetChecklistMonthComponent },
      { path: 'timesheet-checklist-year', component: TimesheetChecklistYearComponent },
      { path: 'timesheet-report-accounting', component: TimesheetReportAccountingComponent },
      { path: 'timesheet-checklist-orgcode', component: TimesheetChecklistOrgcodeComponent },
      { path: 'timesheet-checklist-year-all', component: TimesheetChecklistYearAllComponent },
      { path: 'timesheet-checklist-month-all', component: TimesheetChecklistMonthAllComponent },
      { path: 'timesheet-checklist-division-all', component: TimesheetChecklistDivisionAllComponent },

      { path: 'expense-claims', component: ExpenseClaimsComponent },
      { path: 'expense-worklist', component: ExpenseWorklistComponent },
      { path: 'expense-claims-item', component: ExpenseClaimsItemComponent },

      { path: 'sale-labor-rate-master', component: SaleLaborRateMasterComponent },
      { path: 'timesheet-summary-report', component: TimesheetSummaryReportComponent },

      { path: 'effort-management', component: EffortManagementComponent },
      { path: 'effort-group', component: EffortGroupComponent },
      { path: 'effort-plan', component: EffortPlanComponent },

      { path: 'project-effort-estimation', component: ProjectEffortEstimationComponent },
      { path: 'project-plan-actual-compare-report', component: ProjectPlanActualCompareReportComponent },
      { path: 'project-plan-actual-compare-report', component: ProjectAssignManagerComponent },
      { path: 'sale-target-management', component: SaleTargetManagementComponent },
      { path: 'channel-type-management', component: ChannelTypeManagementComponent },
      { path: 'channel-mapping', component: ChannelMappingComponent },
      { path: 'dealer-mapping', component: DealerMappingComponent },
      { path: 'lead-summary-by-channel', component: LeadSummaryByChannelComponent },
      { path: 'sale-report', component: SaleReportComponent },
      { path: 'service-delivery-backlog', component: ServiceDeliveryBacklogComponent },
      { path: 'service-delivery-backlog-detail', component: ServiceDeliveryBacklogDetailComponent },
      { path: 'projectsalereport', component: ProjectsalereportComponent },
      { path: 'profitlossreport', component: ProfitLossReportComponent },
      { path: 'product-management', component: ProductManagementComponent },
      { path: 'projectsale-asset-group-report', component: ProjectsaleAssetGroupReportComponent },
      { path: 'project-axis', component: ProjectAxisComponent },
      { path: 'asset-management', component: AssetManagementComponent },
      { path: 'sale-homepage', component: SaleHomepageComponent },
      { path: 'projectsale-edit', component: ProjectsaleEditComponent },
      { path: 'service-delivery-backlog-all', component: ServiceDeliveryBacklogAllComponent },
      { path: 'quotation-management', component: QuotationManagementComponent },
      { path: 'projectsale-asset-group-all-report', component: ProjectsaleAssetGroupAllReportComponent },
      { path: 'pipe-line-elevated', component: PipeLineElevatedComponent },
      { path: 'sale-summary-report', component: SaleSummaryReportComponent },
      { path: 'asset-report-by-customer', component: AssetReportByCustomerComponent },
      { path: 'resource-planning', component: ResourcePlanningComponent },
      { path: 'timesheet-export', component: TimesheetExportComponent },
      { path: 'authorize-user', component: AuthorizeUserComponent },
      { path: 'authorize-user-project/:EmpCode', component: AuthorizeUserProjectComponent },
      { path: 'timesheet-summary-worklist', component: TimesheetSummaryWorklistComponent },
    ]),

    BrowserAnimationsModule,

    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatBadgeModule,
    MatMenuModule,
    MatSidenavModule,
    MatListModule,
    MatCardModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatTabsModule,
    ChartsModule,
    MatExpansionModule,
    ReactiveFormsModule,
    MatChipsModule,
    MatSnackBarModule,
    MatSelectModule,
    NgSelectModule,
    MatCheckboxModule,
    MatDialogModule,
    DragDropModule,
    MatNativeDateModule,
    MatRippleModule,
    MatDatepickerModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBnH-R9zXYF9L0a8wl1idTXkrahEtZwD8E',
      libraries: ['places']
    }),
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: msalConfig.auth.clientId,
          authority: `https://login.microsoftonline.com/${msalConfig.tenantId}`,
          redirectUri: msalConfig.auth.redirectUri
        },
        cache: {
          cacheLocation: 'localStorage',
          storeAuthStateInCookie: false
        }
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: msalConfig.scopes
        }
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['User.Read']]
        ])
      }
    )
  ],
  exports: [
    PhoneMaskDirective
  ],
  providers: [
    { provide: ErrorHandler, useClass: SilentErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    MsalGuard,
    MsalService
  ],
  entryComponents: [
    UpdatePipelineDialogComponent,
    ProjectPipelineDetailComponent,
    ServiceDeliveryBacklogDetailComponent,
    ProfitLossReportDialogComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
